if (!customElements.get('search-suggestions')) {
  class SearchSuggestions extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.abortCtrl = null;
      this.defaultHTML = this.innerHTML;

      const forSelector = this.getAttribute('for');
      if (forSelector) this.searchInput = document.querySelector(forSelector);
      if (!this.searchInput) {
        const parentForm = this.closest('form');
        this.searchInput = parentForm?.querySelector('input[name="q"]') || null;
      }
      if (!this.searchInput) this.searchInput = document.querySelector('.main-search__form input[name="q"]') || null;
      if (!this.searchInput) return;

      this.handleInputChange = this.handleInputChange?.bind(this) || this._bindHandle();
      this.searchInput.addEventListener('keyup', this.handleInputChange);
      this.searchInput.addEventListener('change', this.handleInputChange);
    }

    disconnectedCallback() {
      if (this.searchInput && this.handleInputChange) {
        this.searchInput.removeEventListener('keyup', this.handleInputChange);
        this.searchInput.removeEventListener('change', this.handleInputChange);
      }
      clearTimeout(this.searchTimeoutID);
      if (this.abortCtrl) this.abortCtrl.abort('component-disconnected');
    }

    _bindHandle() {
      return () => {
        const valueToSearch = this.searchInput.value || '';
        if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
          clearTimeout(this.searchTimeoutID);
          this.searchTimeoutID = setTimeout(() => this.fetchSuggestions(valueToSearch), 500);
        } else if (!valueToSearch.length) {
          clearTimeout(this.searchTimeoutID);
          if (this.abortCtrl) { this.abortCtrl.abort('no-query'); this.abortCtrl = null; }
          this.innerHTML = this.defaultHTML; 
        }
        this.oldSearchValue = valueToSearch;
      };
    }

    fetchSuggestions(terms) {
  if (this.abortCtrl) this.abortCtrl.abort('new-request');
  this.abortCtrl = new AbortController();

  fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, { signal: this.abortCtrl.signal })
    .then(res => { if (!res.ok) throw new Error(res.status); return res.text(); })
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const wrapper = doc.querySelector('.search-suggestions-wrapper') || doc.body.firstElementChild;
      this.innerHTML = '';
      if (wrapper) this.insertAdjacentElement('beforeend', wrapper);
    })
    .catch(err => { if (err.name !== 'AbortError') console.warn('[search-suggestions] fetch error:', err); });
}
  }
  window.customElements.define('search-suggestions', SearchSuggestions);
}
